import React from 'react';
import { FormattedMessage } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography';

import { ListingPageHelpLink } from '@futrli/ui-components/components/listing-page/listing-page-help-link/listing-page-help-link';

export const BasicInfo = () => (
  <Box mb={3}>
    <Box display="flex" alignItems="center">
      <Typography variant="h1" fontSize="24px" fontWeight="700" mb={0} mr="24px">
        <FormattedMessage id="predict.chart_of_accounts" defaultMessage="Chart of accounts" />
      </Typography>
      <ListingPageHelpLink url="https://support.futrli.com/en/articles/14597391-chart-of-accounts" />
    </Box>
  </Box>
);
